import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  button: {
    padding: 8,
  },

  header: {
    fontSize: "2rem",
    fontWeight: 700,
  },
}));

const ColumnHeader = ({
  buttonText,
  customButton = null,
  header,
  onClick,
  paddingBottom = "24px",
}) => {
  const classes = useStyles();
  return (
    <Grid
      container
      item
      justifyContent="space-between"
      alignItems="center"
      style={{ paddingBottom: paddingBottom }}
    >
      <header>
        <Typography variant="h6">{header}</Typography>
      </header>
      {customButton ? (
        customButton
      ) : onClick ? (
        <Button
          className={classes.button}
          variant="outlined"
          color="primary"
          onClick={onClick}
        >
          {buttonText}
        </Button>
      ) : null}
    </Grid>
  );
};

export default ColumnHeader;
